import React from 'react';
import { Phone, MessageCircle, MapPin, ShieldCheck, Clock, Zap } from 'lucide-react';
import { Button } from '../ui/button';
import { COMPANY_INFO } from '../../mock';

const TRUST_ITEMS = [
  { icon: MapPin, text: 'Direkt vor Ort' },
  { icon: MapPin, text: 'Bundesweit im Einsatz' },
  { icon: ShieldCheck, text: 'Unabhängig' },
  { icon: Zap, text: 'Schnelle Terminvergabe' }
];

export const HeroBundesweit = () => {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center pt-24 pb-20 overflow-hidden bg-gradient-to-br from-gray-900 via-black to-gray-900">
      {/* Decorative gradient blobs */}
      <div className="absolute top-20 right-10 w-[500px] h-[500px] bg-brand-green/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-10 w-[400px] h-[400px] bg-brand-green/10 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <div className="space-y-10 animate-fadeInUp">
          {/* H1 */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white leading-[1.1] tracking-tighter">
            Unfallgutachten
            <br />
            <span className="gradient-text">bundesweit –</span>
            <br />
            <span className="text-gray-400 text-4xl sm:text-5xl lg:text-6xl">direkt vor Ort</span>
          </h1>

          {/* Subline */}
          <p className="text-xl lg:text-2xl text-gray-400 max-w-3xl mx-auto leading-relaxed font-normal">
            Wir koordinieren Termine flexibel und kommen nach Absprache dorthin, wo Sie uns brauchen.
            <br className="hidden sm:block" />
            Schnell, unabhängig und mit klarer Dokumentation.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <a href={`tel:${COMPANY_INFO.phone}`}>
              <Button size="lg" className="w-full sm:w-auto bg-brand-green hover:bg-brand-green-dark text-white text-lg px-10 py-7 rounded-2xl font-semibold shadow-2xl shadow-brand-green/30">
                <Phone className="w-5 h-5 mr-3" />
                Jetzt anrufen
              </Button>
            </a>
            <a href={`https://wa.me/${COMPANY_INFO.whatsapp}`} target="_blank" rel="noopener noreferrer">
              <Button size="lg" variant="outline" className="w-full sm:w-auto border-2 border-white text-white hover:bg-white hover:text-gray-900 text-lg px-10 py-7 rounded-2xl font-semibold">
                <MessageCircle className="w-5 h-5 mr-3" />
                WhatsApp schreiben
              </Button>
            </a>
          </div>

          {/* Trust-Bar */}
          <div className="flex flex-wrap justify-center items-center gap-8 text-[15px] pt-6">
            {TRUST_ITEMS.map((item, index) => {
              const Icon = item.icon;
              return (
                <div key={index} className="flex items-center gap-2.5 text-gray-300">
                  <div className="w-10 h-10 bg-brand-green/15 rounded-xl flex items-center justify-center border border-brand-green/25">
                    <Icon className="w-5 h-5 text-brand-green" />
                  </div>
                  <span className="font-medium">{item.text}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};